import { Doc } from "yjs";
// For this example we use the WebrtcProvider to synchronize the document
// between multiple clients. Other providers are available.
// You can find a list here: https://docs.yjs.dev/ecosystem/connection-provider
import { io } from "socket.io-client";
import { NP_SOCKET_API_URL } from "../config/constants";
import { getAccessToken } from "../utils/authTokenStore";

// The access token lives in memory and changes on refresh. The `auth` callback runs on every
// (re)connect, so each handshake carries the latest token (browsers ignore `extraHeaders` for
// the WebSocket transport). The server reads it from `socket.handshake.auth.token`.
export const socket = io(NP_SOCKET_API_URL ?? "", {
  autoConnect: false,
  auth: cb => cb({ token: getAccessToken() })
});
const ydoc = new Doc();

export default ydoc;
